export const changeLog = {
    changeLogTitle: "Change Log",
    help: {
        tooltip: "What is tracked",
        title: "What is tracked in the change log",
        layersCreatedDeleted: "Layer creations and deletions.",
        mapObjectsGrouped: "Map object creations, deletions and geometry edits grouped by user and hour.",
        mapObjectEditHint: "Unique Map object edits count as one edit if they happen within 5 minutes of each other.",
        layerOperationsGrouped: "Layer copy, import and unlink operations.",
    },
    dateTimes: {
        today: "Today",
        yesterday: "Yesterday",
        todayAt: "Today at {{ time }}",
        yesterdayAt: "Yesterday at {{ time }}",
        dayAt: "{{ day }} at {{ time }}",
        aWeekAgo: "A week ago",
        weekday0: "Sunday",
        weekday1: "Monday",
        weekday2: "Tuesday",
        weekday3: "Wednesday",
        weekday4: "Thursday",
        weekday5: "Friday",
        weekday6: "Saturday",
    },
    labels: {
        layerFallbackName: "Layer",
        multipleLayers: "Multiple Layers",
        viewDetails: "View details",
    },
    subTitles: {
        layerImported: "Layer Imported",
        layersImported: "Layers Imported",
        layerUnlinked: "Layer Unlinked",
        layersUnlinked: "Layers Unlinked",
        layerCopied: "Layer Copied",
        layersCopied: "Layers Copied",
        layerCreated: "Layer Created",
        layerDeleted: "Layer Deleted",
        layerEdited: "Layer Edited",
    },
    details: {
        layerImported: "Layer imported: {{ layerName }}",
        layerUnlinked: "Layer unlinked: {{ layerName }}",
        layerCreated: "Layer created: {{ layerName }}",
        mapObjectCreated: "{{ count }} Map Object Created",
        mapObjectsCreated: "{{ count }} Map Objects Created",
        mapObjectUpdated: "{{ count }} Map Object Edited",
        mapObjectsUpdated: "{{ count }} Map Objects Edited",
        mapObjectDeleted: "{{ count }} Map Object Deleted",
        mapObjectsDeleted: "{{ count }} Map Objects Deleted",
    },
} as const;
